/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import { formatDate, getNewDate, isEmpty } from '../../helper-utils/appUtils';

function AppTimePicker({
  name,
  label,
  selectedTime,
  onChange,
  placeholder,
  minDate,
  maxDate,
  disabled,
  className,
  customClassName,
  monthsShown,
  labelClassName,
  valueClassName,
  showPreviousMonths,
  customMobileClass,
  showDay,
  required,
  isCustomeInput,
  ...rest
}) {
  return (
    <div
      className={customClassName}
      style={{ backgroundColor: disabled ? '#E9E9E9' : '#fff' }}
    >
      <label
        htmlFor={name}
        className={`app-date-label ${
          required ? 'required' : ''
        } ${labelClassName}`}
      >
        {label}
      </label>
      <DatePicker
        placeholderText={placeholder}
        selected={selectedTime}
        onChange={onChange}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeCaption="Time"
        dateFormat="h:mm aa"
        disabled={disabled}
        calendarClassName={className}
        {...rest}
      />
      {showDay && !isEmpty(selectedTime) && (
        <span style={{ marginTop: '-2px' }}>
          {formatDate(getNewDate(selectedTime), 'dddd')}
        </span>
      )}
    </div>
  );
}

AppTimePicker.defaultProps = {
  minDate: '',
  maxDate: '',
  showPreviousMonths: false,
  disabled: false,
  className: '',
  customClassName: '',
  name: '',
  label: '',
  labelClassName: '',
  valueClassName: ' ',
  placeholder: '',
  required: false,
  showDay: undefined,
  isCustomeInput: true,
};

AppTimePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  disabled: PropTypes.bool,
  showPreviousMonths: PropTypes.bool,
  className: PropTypes.string,
  customClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  selectedTime: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showDay: PropTypes.bool,
  required: PropTypes.bool,
  isCustomeInput: PropTypes.bool,
  valueClassName: PropTypes.string,
};
export default AppTimePicker;
